import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupChartId, getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import DisaggregateMetricCard from "../DisaggregateMetricCard";
import RaceEthnicityChart from "../charts/RaceEthnicityChart";
import BannerRibbon from "../BannerRibbon";

const DemographicMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const demoOrders = getMetricGroupOrderIds(tab);

    const sortedDemoMetrics = demoOrders.map((order: number[]) => 
        categorizedData.Demographics
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('Demographic metrics:', sortedDemoMetrics);

    const demoOne: DisaggregatedMetric[] = sortedDemoMetrics[0];

    let metricsForTab = indicators; // Get metrics for the current tab

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    return (
        <>    
            <div className="mb-2">
                <BannerRibbon text="Demographic Characteristics" color="#225591"/>
            </div>         
            <p className="text-port-text mx-4 text-[10px] mb-4">Data updates published July 15, 2025. Data testing in progress.</p>
            <p className="text-lacey-text ml-4 text-xs mt-4">Indicators shown below depict demographic details for the population within the selected area.</p>
            <div className="grid grid-cols-2 gap-4 place-items-start ml-4">
                {demoOne.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}

                <div className="col-span-2 w-full pr-4">
                    {categorizedData.Demographics.filter(metric => 
                        [getMetricGroupChartId(tab, "race")].includes(metric.id) // Race and Ethnicity
                    ).map(metric => (
                        <DisaggregateMetricCard
                            key={metric.id}
                            id={metric.id}
                            metric={metric}
                            title={"Race & Ethnicity"}
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            showValue={false}
                        />
                    ))}
                    <RaceEthnicityChart indicators={indicators} title="Race and Ethnicity" tab="Demographics" chartName="race" height="h-80" barColor="#00A18A" reverseOrder={false} topFive={false}/>
                </div>
            </div>
        </>
    );
}

export default DemographicMetrics;